import { onViewChange, allToTallest } from '@/resources/assets/js/modules/utils';

class HeaderSolutions {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.cardsTitles = [...this.root.querySelectorAll('.Card-text h2')];
    this.cardsSupport = [...this.root.querySelectorAll('.Card-text > p')];

    this.#init();
  }

  #init() {
    if (window.innerWidth < 992 || this.cardsSupport.length == 0) return;
    allToTallest(this.cardsSupport);
    allToTallest(this.cardsTitles);
    onViewChange(allToTallest.bind(this, this.cardsSupport));
    onViewChange(allToTallest.bind(this, this.cardsTitles));
  }
}

[...document.querySelectorAll('.HeaderSolutions')].forEach(node => {
  new HeaderSolutions(node);
});